import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/dashboard/widgets/shared/StatusBadge";
import { useImpersonation } from "@/contexts/ImpersonationContext";
import { useLinkCustomerPo } from "@/hooks/use-link-customer-po";
import { hasMinRole } from "@/lib/constants";

/**
 * VIB-2575: synlig PowerOffice-status for en kunde, med nytt forsøk.
 *
 * En kunde uten `poweroffice_customer_id` kan ikke faktureres, og tidligere
 * var det bare event_log som visste om det. Merket står på kundekortet og på
 * prosjektet til kunden er koblet. Knappen kaller `ensure-po-customer`; en
 * vellykket kobling oppretter også PO-prosjekt for kundens åpne prosjekter.
 *
 * `external` (regnskap/revisor) ser merket, men ikke knappen.
 */
export default function PoLinkStatus({
  customerId,
  poCustomerId,
  projectId,
}: {
  customerId: string;
  poCustomerId: number | null | undefined;
  projectId?: string;
}) {
  const { activeUser } = useImpersonation();
  const linkCustomer = useLinkCustomerPo();

  if (poCustomerId) return null;

  const canLink = hasMinRole(activeUser?.role ?? "external", "user");

  return (
    <div className="flex flex-wrap items-center gap-2">
      <StatusBadge tone="near" label="Ikke koblet til PowerOffice" />
      {canLink && (
        <Button
          type="button"
          size="sm"
          variant="outline"
          className="h-7 text-xs"
          disabled={linkCustomer.isPending}
          onClick={() => linkCustomer.mutate({ customerId, projectId })}
        >
          {linkCustomer.isPending ? "Kobler til …" : "Koble til PowerOffice"}
        </Button>
      )}
    </div>
  );
}
